module.exports = __webpack_public_path__ + "static/media/ctc_event_2.8c2c5263.jpeg";